import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "./RootNavigation";
import IconButton from "../components/IconButton";
import HStack from "../ui_atoms/HStack";
import ScreenTitle from "../components/ScreenTitle";
import { useNavigation } from "@react-navigation/native";
import { useIsScreenSizeMin } from "../hooks/useIsScreenSizeMin";
import ModalDialogFrame from "../components/ModalDialogFrame";

type ScreenParams = StackScreenProps<RootStackParamList>;

type ModalScreenWrapperProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: React.FC<any>;
    title?: string;
};

export const ModalScreenWrapper = ({
    component: Component,
    title,
    ...props
}: ModalScreenWrapperProps) => {
    const isLarge = useIsScreenSizeMin("large");
    const navigation = useNavigation<ScreenParams["navigation"]>();
    // On native the native modal provides the frame + header; only desktop web adds the dialog box
    // (with title/close) via the shared ModalDialogFrame.
    if (!isLarge) {
        return <Component {...props} />;
    }
    return (
        <ModalDialogFrame>
            <HStack h="2/3" v={0.5} style={{ justifyContent: "space-between" }}>
                <ScreenTitle>{title}</ScreenTitle>
                <IconButton
                    testID="close-button"
                    onPress={() => {
                        navigation.goBack();
                    }}
                    icon="close"
                    size={28}
                />
            </HStack>
            <Component {...props} />
        </ModalDialogFrame>
    );
};
